import { ImageDescriptor } from '@play-co/timestep-core';
import {
  ImageScaleView,
  ImageScaleViewOpts,
  MaskView,
  View,
} from '@play-co/timestep-core/ui';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';

type CommonOpts = {
  superview?: View;
  tag?: string;
  image?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  centerOnOrigin?: boolean;
};

export type AvatarOpts =
  | (CommonOpts & {
      onClick: undefined;
      tracking: undefined;
    })
  | (CommonOpts & {
      onClick?: () => Promise<void>;
      tracking?: {
        feature: string;
        $subFeature: string;
      };
    });

export class Avatar extends ButtonScaleView {
  public get borderView(): ImageScaleView {
    return this.border;
  }

  public get maskView(): MaskView {
    return this.mask;
  }

  private mask: MaskView;
  private avatar: ImageScaleView;
  private border: ImageScaleView;

  constructor({
    superview,
    image,
    x = 0,
    y = 0,
    width = 130,
    height = 130,
    tracking = {
      feature: 'avatar',
      $subFeature: 'avatar-tap',
    },
    onClick,
    tag,
    centerOnOrigin = true,
  }: AvatarOpts) {
    super({
      superview,
      x,
      y,
      width,
      height,
      onClick: onClick,
      tracking,
      tag,
      centerOnOrigin,
    });

    const border = 6;

    // Border
    this.border = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/icons/icon_avatar_generic.png',
      width: width,
      height: height,
    });

    // Mask
    this.mask = new MaskView({
      superview: this,
      mask: 'assets/ui/shared/icons/icon_avatar_generic.png',
      width: width - border,
      height: height - border,
      x: border / 2,
      y: border / 2,
    });

    // Avatar
    this.avatar = new ImageScaleView({
      superview: this.mask,
      image,
      width,
      height,
    });
  }

  public updateImage(
    image?: string | ImageDescriptor,
    opts?: ImageScaleViewOpts,
  ) {
    this.avatar.setImage(image, opts);
  }
}
